import useConfig from './useConfig'

const useEvmChain = (chainId?: string) => {
  const { evmChains } = useConfig()

  return evmChains.find((chain) => chain.chainId.toString() === chainId)
}

export default useEvmChain
